import {KpiCalculationError} from '@hconnect/common/types'

import {ExpertSystemUsageRateColumnKeys, MonthColumns, MonthDataColumns} from '../types'

export const ESUR_TABLE_WIDTHS = {
  LOCATION: 315,
  MILL_TYPE: 120,
  EXPERT_SYSTEM_NAME: 120,
  OTHER: 200,
  MONTH: 110,
  AVERAGE: 172,
  WEIGHTED_AVERAGE: 172
}

export const ESUR_TABLE_LEFTS = {
  LOCATION: 0,
  MILL_TYPE: ESUR_TABLE_WIDTHS.LOCATION,
  EXPERT_SYSTEM_NAME: ESUR_TABLE_WIDTHS.LOCATION + ESUR_TABLE_WIDTHS.MILL_TYPE
}

export const EXPERT_SYSTEM_USAGE_TABLE_KEYS = Object.values(ExpertSystemUsageRateColumnKeys)

export const STICKY_COLUMNS_CONFIG: {
  left: Partial<Record<ExpertSystemUsageRateColumnKeys, {width: number; left: number}>>
  right: Partial<Record<ExpertSystemUsageRateColumnKeys, {width: number; right: number}>>
} = {
  left: {
    [ExpertSystemUsageRateColumnKeys.LOCATION]: {
      width: ESUR_TABLE_WIDTHS.LOCATION,
      left: ESUR_TABLE_LEFTS.LOCATION
    },
    [ExpertSystemUsageRateColumnKeys.MILL_TYPE]: {
      width: ESUR_TABLE_WIDTHS.MILL_TYPE,
      left: ESUR_TABLE_LEFTS.MILL_TYPE
    },
    [ExpertSystemUsageRateColumnKeys.EXPERT_SYSTEM_NAME]: {
      width: ESUR_TABLE_WIDTHS.EXPERT_SYSTEM_NAME,
      left: ESUR_TABLE_LEFTS.EXPERT_SYSTEM_NAME
    }
  },
  right: {
    [ExpertSystemUsageRateColumnKeys.AVERAGE]: {
      width: ESUR_TABLE_WIDTHS.AVERAGE,
      right: ESUR_TABLE_WIDTHS.WEIGHTED_AVERAGE
    },
    [ExpertSystemUsageRateColumnKeys.WEIGHTED_AVERAGE]: {
      width: ESUR_TABLE_WIDTHS.WEIGHTED_AVERAGE,
      right: 0
    }
  }
}

export const MONTH_KEYS: ExpertSystemUsageRateColumnKeys[] = [
  ExpertSystemUsageRateColumnKeys.JAN,
  ExpertSystemUsageRateColumnKeys.FEB,
  ExpertSystemUsageRateColumnKeys.MAR,
  ExpertSystemUsageRateColumnKeys.APR,
  ExpertSystemUsageRateColumnKeys.MAY,
  ExpertSystemUsageRateColumnKeys.JUN,
  ExpertSystemUsageRateColumnKeys.JUL,
  ExpertSystemUsageRateColumnKeys.AUG,
  ExpertSystemUsageRateColumnKeys.SEP,
  ExpertSystemUsageRateColumnKeys.OCT,
  ExpertSystemUsageRateColumnKeys.NOV,
  ExpertSystemUsageRateColumnKeys.DEC
]

export const MONTH_MAP: Record<string, keyof MonthDataColumns[string]> = {
  '01': 'jan',
  '02': 'feb',
  '03': 'mar',
  '04': 'apr',
  '05': 'may',
  '06': 'jun',
  '07': 'jul',
  '08': 'aug',
  '09': 'sep',
  '10': 'oct',
  '11': 'nov',
  '12': 'dec'
}

export const monthMapStringToDigit: Record<keyof MonthColumns, string> = {
  jan: '01',
  feb: '02',
  mar: '03',
  apr: '04',
  may: '05',
  jun: '06',
  jul: '07',
  aug: '08',
  sep: '09',
  oct: '10',
  nov: '11',
  dec: '12'
}

export const MONTH_REVERSE_MAP = Object.fromEntries(
  Object.entries(MONTH_MAP).map(([key, value]) => [value, key])
) as Record<keyof (typeof MONTH_MAP)[keyof typeof MONTH_MAP], keyof typeof MONTH_MAP>

export const VALIDATION_TRANSLATIONS_KEY: Record<KpiCalculationError, string> = {
  [KpiCalculationError.EmptyKpiValue]: 'label.notApplicable',
  [KpiCalculationError.EquipmentNotRunning]: 'label.notRunning',
  [KpiCalculationError.NoKpiValue]: 'label.notApplicable',
  [KpiCalculationError.AmbiguousKpiValues]: 'label.notApplicable',
  [KpiCalculationError.UnrecognizedControlString]: 'label.notApplicable',
  [KpiCalculationError.InvalidNumericValue]: 'label.notApplicable'
}

export const MIN_VALUE = 0
export const MAX_VALUE = 100

// 5 seconds
export const DIRTY_POLL_INTERVAL = 5000

export const PROVIDERS = {
  hmg2: 'HM-G2',
  fls: 'FLS',
  hmplc: 'HM-PLC',
  abb: 'ABB',
  siemens: 'Siemens',
  akxa: 'AKXA'
}

export const DAY_KEYS: string[] = Array.from({length: 31}, (_, i) => `${i + 1}`)

export const ESDR_TABLE_WIDTHS = {
  LOCATION: ESUR_TABLE_WIDTHS.LOCATION,
  DAY: 110,
  AVERAGE: ESUR_TABLE_WIDTHS.AVERAGE
}

export const ESDR_TABLE_LEFTS = {
  LOCATION: ESUR_TABLE_LEFTS.LOCATION
}
